import { Icon, IIconProps } from 'native-base';
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export const DropletsIcon = ({ size = 'sm', ...props }: IIconProps) => {
  return (
    <Icon size={size} viewBox="0 0 10 10" fill="none" {...props}>
      <G clip-path="url(#clip0_26234_3744)">
        <Path
          d="M5.23333 2.53329C5.5199 2.07543 5.72304 1.57039 5.83333 1.04163C6.04167 2.08329 6.66667 3.08329 7.5 3.74996C8.33333 4.41663 8.75 5.20829 8.75 6.04163C8.75238 6.61758 8.5837 7.18127 8.26533 7.66125C7.94697 8.14122 7.49326 8.51586 6.96172 8.73766C6.43019 8.95947 5.84476 9.01846 5.27966 8.90716C4.71455 8.79585 4.19522 8.51927 3.7875 8.11246M2.91667 6.57496C3.83333 6.57496 4.58333 5.81246 4.58333 4.88746C4.58333 4.40413 4.34583 3.94579 3.87083 3.55829C3.39583 3.17079 3.0375 2.59579 2.91667 1.99163C2.79583 2.59579 2.44167 3.17496 1.9625 3.55829C1.48333 3.94163 1.25 4.40829 1.25 4.88746C1.25 5.81246 2 6.57496 2.91667 6.57496Z"
          stroke="#0086C9"
          strokeWidth="0.833333"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_26234_3744">
          <Rect width="10" height="10" fill="white" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
